import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Phone(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="150"
      viewBox="0 0 197 150"
      width="197"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_41571_203750"
          x1="263.196"
          x2="4.88744"
          y1="26.4836"
          y2="33.3554"
        >
          <stop offset="0.0222184" stopColor="white" />
          <stop offset="0.76744" stopColor="#F5F8FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_41571_203750"
          x1="85.7305"
          x2="122.239"
          y1="66.5552"
          y2="142.061"
        >
          <stop stopColor="#F0F5FD" />
          <stop offset="1" stopColor="#C4D1ED" />
        </linearGradient>
      </defs>
      <path
        d="M133.407 149.89L37.0805 149.89C37.0805 149.89 1.52588e-05 149.89 1.52588e-05 102.257C1.52588e-05 54.6245 52.0901 74.5698 100.701 19.5952C142 -27.1102 197 19.3552 197 58.3899C197 112.924 142.243 109.475 133.407 149.89Z"
        fill="url(#paint0_linear_41571_203750)"
      />
      <rect
        fill="url(#paint1_linear_41571_203750)"
        height="140"
        rx="10"
        width="73.5897"
        x="62"
        y="9.88965"
      />
      <rect
        height="137.6"
        rx="8.77592"
        stroke="#E1E7F5"
        strokeWidth="2.4"
        width="71.1897"
        x="63.2"
        y="11.0896"
      />
      <path
        d="M85.333 11.6846H112.256V11.949C112.256 13.7855 110.767 15.2743 108.931 15.2743H88.6583C86.8218 15.2743 85.333 13.7855 85.333 11.949V11.6846Z"
        fill="#E1E7F5"
      />
      <rect
        fill="white"
        height="1.79487"
        rx="0.897436"
        width="25.1282"
        x="86.2314"
        y="140.915"
      />
      <rect fill="#CCD8F0" height="3" rx="1" width="31" x="70" y="64" />
      <path
        d="M72.3636 47.5455H70.4016L73.3516 52.2727L70.3647 57H72.3406L74.4457 53.5607H74.5195L76.6246 57H78.6097L75.6506 52.2727L78.5636 47.5455H76.6108L74.5195 51.0078H74.4457L72.3636 47.5455ZM81.3392 47.5455H79.3772L82.3271 52.2727L79.3403 57H81.3161L83.4213 53.5607H83.4951L85.6002 57H87.5853L84.6262 52.2727L87.5392 47.5455H85.5864L83.4951 51.0078H83.4213L81.3392 47.5455ZM90.3148 47.5455H88.3528L91.3027 52.2727L88.3159 57H90.2917L92.3968 53.5607H92.4707L94.5758 57H96.5609L93.6017 52.2727L96.5147 47.5455H94.562L92.4707 51.0078H92.3968L90.3148 47.5455ZM102.515 47.5455H100.553L103.503 52.2727L100.516 57H102.492L104.597 53.5607H104.671L106.776 57H108.761L105.802 52.2727L108.715 47.5455H106.762L104.671 51.0078H104.597L102.515 47.5455ZM111.491 47.5455H109.529L112.479 52.2727L109.492 57H111.468L113.573 53.5607H113.646L115.752 57H117.737L114.778 52.2727L117.691 47.5455H115.738L113.646 51.0078H113.573L111.491 47.5455ZM120.466 47.5455H118.504L121.454 52.2727L118.467 57H120.443L122.548 53.5607H122.622L124.727 57H126.712L123.753 52.2727L126.666 47.5455H124.713L122.622 51.0078H122.548L120.466 47.5455Z"
        fill="#B0BFDD"
      />
      <rect fill="#CCD8F0" height="3" rx="1" width="44" x="70" y="69" />
    </SvgIcon>
  )
}

export default Phone
